import { Injectable, inject } from '@angular/core'

import { Observable, map } from 'rxjs'

import { DocumentPluginApi } from '@flowx/designer/shared/api/document-plugin.api'

@Injectable({
  providedIn: 'root',
})
export class AiConversationFilesService {
  #documentPluginApi = inject(DocumentPluginApi)

  uploadFile(file: File): Observable<string> {
    return this.#documentPluginApi.uploadTempFile(file).pipe(map(({ id }) => id))
  }
}
